module.exports = __webpack_public_path__ + "static/media/whichThinnerQuestion.e235a52c.mp3";